// extracted by mini-css-extract-plugin
export default {"iconHeader":"header-general-info-styles_iconHeader__cl0JS"};